import { getUserLanguageCode, toLanguageCode } from 'js/lib/language';
import { isAuthenticatedUser } from 'js/lib/user';

import GrowthDiscoveryEpicClient from 'bundles/epic/clients/GrowthDiscovery';

import _t from 'i18n!nls/xdp';

export const showAiDubbingOnXdp = () => GrowthDiscoveryEpicClient.get('enableAiDubbingOnXdp');

const TARGET_LANGUAGES_CODE = ['fr', 'de', 'es'] as const;

export const getAudienceLanguageCode = () => {
  const languageCode = toLanguageCode(isAuthenticatedUser() ? getUserLanguageCode() : _t.getLocale());
  return TARGET_LANGUAGES_CODE.includes(languageCode) ? languageCode : null;
};
